type Tab = { readonly id: string; readonly label: string; readonly count?: number };

type TeacherTabStripProps = {
  readonly tabs: readonly Tab[];
  readonly active: string;
  readonly onSelect: (id: string) => void;
  readonly ariaLabel: string;
};

export function TeacherTabStrip({ tabs, active, onSelect, ariaLabel }: TeacherTabStripProps) {
  return (
    <div className="teacher-tab-strip" role="tablist" aria-label={ariaLabel}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={active === tab.id}
          className={`teacher-tab-strip-btn${active === tab.id ? " is-active" : ""}`}
          onClick={() => onSelect(tab.id)}
        >
          {tab.label}
          {typeof tab.count === "number" ? (
            <span className="teacher-tab-strip-count" aria-label={`${tab.count} lessons`}>
              {tab.count}
            </span>
          ) : null}
        </button>
      ))}
    </div>
  );
}
